export const featureDetailTypes = {
  note: 'Note',
  gene: 'Gene',
  product: 'Product',
};
